import { Card, CardContent } from "@/components/ui/card";
import { useUserBadgesFor } from "@/hooks/useBadges";
import { UserBadgesSection } from "./UserBadgesSection";

/** Card wrapper for the profile page; hidden when the member has no badges. */
export function MyBadgesCard({ userId }: { userId: string | null | undefined }) {
  const { badges } = useUserBadgesFor(userId);
  if (!userId || badges.length === 0) return null;
  return (
    <Card>
      <CardContent className="pt-6">
        <UserBadgesSection userId={userId} />
      </CardContent>
    </Card>
  );
}
